import * as Yup from 'yup';

export const getCashTransitSchema = (registerBalance, safeBalance) =>
  Yup.object({
    amount: Yup.number()
      .typeError('Вкажіть суму')
      .required('Вкажіть суму')
      .min(1, 'Сума має бути більше нуля')
      .when('type', {
        is: 'transfer_out',
        then: (schema) =>
          schema.test(
            'max-from-register',
            'Недостатньо коштів у касі',
            (value) => typeof value === 'number' && value <= registerBalance
          ),
        otherwise: (schema) =>
          schema.test(
            'max-from-safe',
            'Недостатньо коштів у сейфі',
            (value) => typeof value === 'number' && value <= safeBalance
          ),
      }),
    type: Yup.string()
      .required('Оберіть тип транзакції')
      .oneOf(['transfer_in', 'transfer_out'], 'Невірний тип транзакції'),
  });
